
import template from './new_account.html';

//Instantiate Page Variables 
var NewAccountViewModel = function(page)
{
	var self = this;
	self.page = page;

	this.available_products = ko.observableArray();
	this.company_name = ko.observable('');
	this.account_name = ko.observable('');
	this.email = ko.observable('');
	this.fullnames = ko.observable('');
	this.chosen_product = ko.observable();
	this.valid_email = ko.observable('');
	this.valid_company_name = ko.observable('');
	this.valid_fullnames = ko.observable('');
	let email_filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	let name_regex = /^[a-zA-Z0-9]/;
	this.valid = ko.computed(function() {
		let boolValidate = true;
		
		if (self.email() == null || self.email() == '')
		{
			self.valid_email('A Valid Email Address Is Required');
			boolValidate = false;
		}else{
			self.valid_email('');
		}

		if (!email_filter.test(self.email())) {
			self.valid_email('A Valid Email Address Is Required');
			boolValidate =  false;
		}else{
			self.valid_email('');
		}

		if (self.company_name() == null || self.company_name() == '')
		{
			self.valid_company_name('Company Name Is Required');
			boolValidate = false;
		}else{
			self.valid_company_name('');
		}

		if (!name_regex.test(self.company_name()))
		{
			self.valid_company_name('Please Enter A Company Name With No Special Characters.');
			boolValidate = false;
		}else{
			self.valid_company_name('');
		}

		if (self.fullnames() == null || self.fullnames() == '')
		{
			self.valid_fullnames('Full Name Is Required');
			boolValidate =  false;
		}else{
			self.valid_fullnames('');
		}

		if (!name_regex.test(self.fullnames()))
		{
			self.valid_fullnames('Please Enter A Full Name With No Special Characters.');
			boolValidate =  false;
		}else{
			self.valid_fullnames('');
		}

		
		
		

		if(boolValidate ==false)
		{
			return false;
		}
		else{
			return true;
		}
	});

	this.create_account_click = function() {
		let obj = {
			email: self.email(),
			company_name: self.company_name(),
			product_name: self.chosen_product(),
			fullnames : self.fullnames()
		};
		$.postJSON('/account/create', obj, function(d) {
			if (d.status != 'OK')
			{
				Grape.alert_api_error(d);
				return;
			}
			else
			{
				window.Grape.navigate('/new_account_confirmation');
			}
		});
	};

	this.btnSuggest_click = function(sugg) {
		self.account_name(sugg.name);
		self.suggestions.remove(sugg);
	};
}

//Handle interaction with page 
var NewAccount = function(bindings) {
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new NewAccountViewModel(this);
	this.name = 'NewAccountPage';

	//Event (Post/After): Load once
	this.init = function() {
		document.title = 'Create New Account';
	};

	//Event (Post/After): Refresh page data
	this.updateData = function() {
		$.getJSON('/available_products', {}, function(res) {
			if (res.status != 'OK')
			{
				Grape.alert_api_error(res);
				return;
			}
		
			self.viewModel.available_products(res.list);
		});
	};

	//Event (Pre/Before): Remove 
	this.teardown = function() {
	};

};

//Assign Page(HTML/JS) to Grape
export default {
	route: '[/]new_account',
	page_class: NewAccount,
	template: template
}

